// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-calendar {
  padding-top: 15px;
  background: var(--ons-color-primary-background);
}
.tracking-calendar-header {
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
}
.tracking-calendar-header-month {
  display: flex;
  align-items: center;
  color: var(--ons-color-black-2);
  font-size: 12px;
  font-family: var(--ons-font-medium);
  cursor: pointer;
}
.tracking-calendar-header-month.prev-month ion-icon {
  margin-right: 5px;
}
.tracking-calendar-header-month.next-month ion-icon {
  margin-left: 5px;
}
.tracking-calendar-header-month.active {
  font-family: var(--ons-font-black);
}
.tracking-calendar-month-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tracking-calendar-month-container .desktop-slide-arrow {
  display: none;
  min-width: 50px;
  width: 50px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.tracking-calendar-month {
  padding: 15px 5px;
  display: flex;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.tracking-calendar-month::-webkit-scrollbar {
  display: none;
}
.tracking-calendar-month-day {
  min-width: 14.2857142857%;
  width: 14.2857142857%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--ons-color-primary-black);
  font-size: 12px;
  cursor: pointer;
}
.tracking-calendar-month-day-of-week {
  opacity: 0.4;
  font-family: var(--ons-font-medium);
  font-size: 10px;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.tracking-calendar-month-day-number {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid var(--ons-color-light-grey);
}
.tracking-calendar-month-day-number.today {
  background: var(--ons-grey-border);
  color: var(--ons-color-light);
  border: 0;
}
.tracking-calendar-month-day.active {
  position: relative;
}
.tracking-calendar-month-day.active:before {
  content: "";
  bottom: 0;
  width: 100%;
  left: 0;
  position: absolute;
  background: var(--ons-color-primary);
  height: 40px;
  z-index: 0;
}
.tracking-calendar-month-day.active.first-active:before {
  left: 50%;
  width: 50%;
}
.tracking-calendar-month-day.active.last-active:before {
  right: 50%;
  left: unset;
  width: 50%;
}
.tracking-calendar-month-day.active.first-active.last-active:before {
  display: none;
}
.tracking-calendar-month-day.active .tracking-calendar-month-day-number {
  background: var(--ons-color-primary);
  color: var(--ons-color-primary-black);
  z-index: 1;
}
.tracking-calendar-month-day.current-highlighted .tracking-calendar-month-day-of-week {
  z-index: 2;
}
.tracking-calendar-month-day.current-highlighted .tracking-calendar-month-day-number {
  box-shadow: 0 0 0 1.3vw var(--ons-color-primary-background);
}
.tracking-calendar-month-day.current-highlighted .tracking-calendar-month-day-number {
  border: 0;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

@media screen and (min-width: 1024px) {
  .tracking-calendar-month {
    margin: 0 auto;
    width: calc(100% - 100px);
  }
  .tracking-calendar-month-container .desktop-slide-arrow {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/tracking-calendar/tracking-calendar.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,+CAAA;AACJ;AACI;EACI,eAAA;EACA,aAAA;EACA,8BAAA;AACR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AACZ;AAEgB;EACI,iBAAA;AAApB;AAKgB;EACI,gBAAA;AAHpB;AAQY;EACI,kCAAA;AANhB;AAWI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AATR;AAWQ;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AATZ;AAaI;EACI,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AAXR;AAaQ;EACI,aAAA;AAXZ;AAcQ;EACI,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,eAAA;EACA,eAAA;AAZZ;AAcY;EACI,YAAA;EACA,mCAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAZhB;AAeY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;AAbhB;AAegB;EACI,kCAAA;EACA,6BAAA;EACA,SAAA;AAbpB;AAiBY;EACI,kBAAA;AAfhB;AAiBgB;EACI,WAAA;EACA,SAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAfpB;AAkBgB;EACI,SAAA;EACA,UAAA;AAhBpB;AAmBgB;EACI,UAAA;EACA,WAAA;EACA,UAAA;AAjBpB;AAoBgB;EACI,aAAA;AAlBpB;AAqBgB;EACI,oCAAA;EACA,qCAAA;EACA,UAAA;AAnBpB;AAyBoB;EACI,UAAA;AAvBxB;AA0BoB;EACI,2DAAA;AAxBxB;AA4BgB;EACI,SAAA;AA1BpB;;AAiCA;EACI,YAAA;EACA,oBAAA;AA9BJ;;AAiCA;EACI;IACI,cAAA;IACA,yBAAA;EA9BN;EAgCE;IACI,aAAA;EA9BN;AACF","sourcesContent":[".tracking-calendar {\n    padding-top: 15px;\n    background: var(--ons-color-primary-background);\n\n    &-header {\n        padding: 0 30px;\n        display: flex;\n        justify-content: space-between;\n\n        &-month {\n            display: flex;\n            align-items: center;\n            color: var(--ons-color-black-2);\n            font-size: 12px;\n            font-family: var(--ons-font-medium);\n            cursor: pointer;\n\n            &.prev-month {\n                ion-icon {\n                    margin-right: 5px;\n                }\n            }\n\n            &.next-month {\n                ion-icon {\n                    margin-left: 5px;\n                }\n            }\n            \n\n            &.active {\n                font-family: var(--ons-font-black);\n            }\n        }\n    }\n\n    &-month-container {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        .desktop-slide-arrow {\n            display: none;\n            min-width: 50px;\n            width: 50px;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n        }\n    }\n\n    &-month {\n        padding: 15px 5px;\n        display: flex;\n        overflow-x: auto;\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n\n        &::-webkit-scrollbar {\n            display: none;\n        }\n\n        &-day {\n            min-width: calc(100% / 7);\n            width: calc(100% / 7);\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            color: var(--ons-color-primary-black);\n            font-size: 12px;\n            cursor: pointer;\n\n            &-of-week {\n                opacity: 0.4;\n                font-family: var(--ons-font-medium);\n                font-size: 10px;\n                text-transform: uppercase;\n                margin-bottom: 10px;\n            }\n\n            &-number {\n                width: 40px;\n                height: 40px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 50%;\n                border: 1px solid var(--ons-color-light-grey);\n\n                &.today {\n                    background: var(--ons-grey-border);\n                    color: var(--ons-color-light);\n                    border: 0;\n                }\n            }\n\n            &.active {\n                position: relative;\n\n                &:before {\n                    content: \"\";\n                    bottom: 0;\n                    width: 100%;\n                    left: 0;\n                    position: absolute;\n                    background: var(--ons-color-primary);\n                    height: 40px;\n                    z-index: 0;\n                }\n\n                &.first-active:before {\n                    left: 50%;\n                    width: 50%;\n                }\n\n                &.last-active:before {\n                    right: 50%;\n                    left: unset;\n                    width: 50%;\n                }\n\n                &.first-active.last-active:before {\n                    display: none;\n                }\n\n                .tracking-calendar-month-day-number {\n                    background: var(--ons-color-primary);\n                    color: var(--ons-color-primary-black);\n                    z-index: 1;\n                }\n            }\n\n            &.current-highlighted {\n                .tracking-calendar-month-day {\n                    &-of-week {\n                        z-index: 2;\n                    }\n\n                    &-number {\n                        box-shadow: 0 0 0 1.3vw var(--ons-color-primary-background);\n                    }\n                }\n\n                .tracking-calendar-month-day-number {\n                    border: 0;\n                }\n            }\n        }\n    }\n}\n\n.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n@media screen and (min-width: 1024px) {\n    .tracking-calendar-month {\n        margin: 0 auto;\n        width: calc(100% - 100px);\n    }\n    .tracking-calendar-month-container .desktop-slide-arrow {\n        display: flex;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
